import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogijratbushirepackage() {



  const cardData =
  {
    keyword: 'Pune to Gujarat Bus Hire Package ',
    heading: 'Sanavi Travels: Pune to Gujarat Bus Hire Package',
    headingDescription: 'Sanavi Travels offers reliable Goa Tour Package from Pune by Bus, providing safe, comfortable, and well-organized travel solutions for families, friends, corporate groups, college tours, and leisure travelers planning a memorable Goa holiday from Pune. Our fleet of luxury AC and Non-AC buses ranging from 32, 35, 40, 45, to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with push-back seating, ample legroom, and spacious luggage capacity to ensure a relaxed overnight and long-distance journey. With experienced long-route drivers, customizable tour packages, transparent pricing, and dedicated trip coordination, Sanavi Travels ensures smooth, punctual, and enjoyable travel. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Goa destinations such as North Goa, South Goa, Baga Beach, Calangute, Candolim, Anjuna, Colva, and Palolem. Choose Sanavi Travels for a trusted Goa tour package from Pune by bus, delivering comfort, safety, and a memorable beach holiday experience.',

    top: 'Top Places to Visit in Rajasthan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most famous and energetic beaches, known for its vibrant nightlife, beach shacks, and thrilling water sports. Visitors can enjoy parasailing, jet skiing, banana boat rides, and dolphin spotting tours. As evening falls, the beach comes alive with music, clubs, and seaside dining. Baga Beach represents Goa’s lively party culture and coastal charm."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, popularly known as the ‘Queen of Beaches’, is the largest beach in North Goa. It features a long stretch of golden sand lined with resorts, restaurants, and shopping stalls. The beach is ideal for swimming, sunbathing, and adventure activities. Calangute perfectly captures Goa’s vibrant tourist atmosphere."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is known for its laid-back vibe, rocky shores, and spectacular sunsets. It is famous for the weekly Anjuna Flea Market, offering handicrafts, clothes, accessories, and souvenirs. The beach has a strong bohemian and trance music heritage. Anjuna attracts backpackers and travelers seeking a relaxed coastal lifestyle."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a 17th-century Portuguese fort overlooking the Arabian Sea, built to defend Goa from invasions. It features massive laterite walls and one of Asia’s oldest lighthouses. The fort offers panoramic views of the coastline and the Mandovi River. Fort Aguada combines history, architecture, and scenic beauty."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most important churches in India. It houses the mortal remains of St. Francis Xavier and reflects beautiful baroque architecture. Pilgrims and tourists from across the world visit this sacred site. The basilica stands as a symbol of Goa’s Portuguese heritage and religious history."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls is one of India’s tallest waterfalls, cascading dramatically through the Western Ghats. The four-tiered waterfall looks like a river of milk, especially during the monsoon season. Visitors can reach the falls via jeep safari or trekking routes. Dudhsagar is a breathtaking natural wonder and a must-visit attraction in Goa."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is known for its crescent-shaped shoreline, calm waters, and peaceful ambiance. It is perfect for swimming, kayaking, and relaxing in beach huts. Compared to North Goa, Palolem offers a quieter and more scenic experience. The beach is ideal for couples and nature lovers."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort is a popular hilltop fort offering stunning views of Vagator Beach and the Arabian Sea. Made famous by Bollywood movies, it is a favorite spot for photography and sunset views. The fort’s ruins add a historic charm to the landscape. Chapora Fort blends cinematic fame with coastal history."
  },
  {
    "title": "Mandovi River Cruise",
    "description": "A cruise on the Mandovi River is a popular Goan experience featuring music, folk dances, and scenic river views. Evening cruises showcase illuminated bridges and vibrant cultural performances. Some cruises also offer casino entertainment onboard. Mandovi River cruises highlight Goa’s festive and relaxed lifestyle."
  },
  {
    "title": "Goa Nightlife & Beach Shacks",
    "description": "Goa is renowned for its electrifying nightlife, beach shacks, and party culture. Areas like Baga, Candolim, Vagator, and Anjuna come alive with DJ nights, live music, and themed parties. Beach shacks serve delicious seafood, cocktails, and Goan cuisine. Goa’s nightlife makes it one of India’s top holiday destinations."
  }
]
,





"services": [
    {
      "name": "Goa Tour Package From Pune by Bus",
      "description": "Goa Tour Package From Pune by Bus offers a comfortable and well-planned travel option for tourists heading to Goa. Ideal for families, friends, and group travelers, this package includes spacious buses, professional drivers, and smooth long-distance travel, ensuring a relaxing journey to Goa’s beaches and tourist attractions."
    },
    {
      "name": "Pune to Goa Bus Tour",
      "description": "Pune to Goa Bus Tour provides reliable bus services for sightseeing and holiday travel from Pune to Goa. Well-maintained buses and experienced chauffeurs ensure safe travel, timely departures, and a pleasant journey for beach holidays, family vacations, or group tours."
    },
    {
      "name": "AC Bus Pune to Goa",
      "description": "AC Bus Pune to Goa offers air-conditioned buses for a cool and comfortable long-distance journey. Ideal for families and groups, these buses provide spacious seating, ample luggage space, and professional drivers for a stress-free travel experience."
    },
    {
      "name": "Luxury Goa Tour Bus",
      "description": "Luxury Goa Tour Bus provides premium buses with comfortable interiors and modern amenities for a refined travel experience. Perfect for luxury holidays, corporate groups, or special tours, this service ensures comfort, safety, and elegance throughout the Goa trip."
    },
    {
      "name": "Family Goa Bus Tour",
      "description": "Family Goa Bus Tour is designed for families traveling together to Goa. Spacious seating, smooth driving, and professional chauffeurs ensure a safe and enjoyable holiday experience for all age groups."
    },
    {
      "name": "Group Travel Goa Bus",
      "description": "Group Travel Goa Bus caters to large groups, tour operators, and organizations planning Goa trips. Comfortable buses and skilled drivers ensure coordinated travel, punctual schedules, and a smooth group touring experience."
    },
    {
      "name": "Affordable Goa Bus Package",
      "description": "Affordable Goa Bus Package offers budget-friendly travel solutions without compromising comfort or safety. Ideal for cost-conscious travelers, this service provides reliable buses, experienced drivers, and transparent pricing for Goa tours."
    },
    {
      "name": "Chauffeur Driven Goa Bus",
      "description": "Chauffeur Driven Goa Bus provides professional drivers experienced in long-distance and night travel. Passengers can relax and enjoy safe, punctual, and hassle-free journeys from Pune to Goa and within Goa."
    },
    {
      "name": "Best Goa Tour Bus Pune",
      "description": "Best Goa Tour Bus Pune offers top-quality buses and professional service for a superior travel experience. Known for reliability, comfort, and disciplined scheduling, this service is ideal for families, friends, and tourists traveling to Goa."
    },
    {
      "name": "Pune Goa Travel Bus",
      "description": "Pune Goa Travel Bus provides dependable long-distance transport between Pune and Goa. Spacious seating, luggage-friendly interiors, and skilled drivers ensure a smooth and comfortable journey for all travelers."
    },
    {
      "name": "Tourist Bus Hire Goa",
      "description": "Tourist Bus Hire Goa offers buses for sightseeing and local travel within Goa. Ideal for visiting beaches, forts, churches, and tourist attractions, this service ensures comfortable, safe, and convenient transportation."
    },
    {
      "name": "Beach Tour Bus Pune",
      "description": "Beach Tour Bus Pune provides dedicated bus services for beach tours and coastal sightseeing in Goa. Comfortable seating and professional drivers ensure relaxed travel for tourists exploring Goa’s famous beaches."
    },
    {
      "name": "Holiday Bus Package Goa",
      "description": "Holiday Bus Package Goa offers organized bus tours for vacations and leisure travel from Pune to Goa. Designed for comfort and convenience, this service is ideal for families, friends, and group holiday planners."
    },
    {
      "name": "Night Travel Bus Goa",
      "description": "Night Travel Bus Goa provides safe and comfortable overnight bus travel between Pune and Goa. Experienced drivers, well-maintained buses, and planned rest stops ensure a secure and restful night journey."
    },
    {
      "name": "Goa Trip Bus Service",
      "description": "Goa Trip Bus Service provides reliable and comfortable buses for complete Goa tours. With professional drivers, spacious seating, and efficient planning, this service ensures a smooth, safe, and memorable travel experience."
    }
  ],
  "tableData": [
    ["Goa Tour Package From Pune by Bus", "Pune to Goa Bus Tour"],
    ["AC Bus Pune to Goa", "Luxury Goa Tour Bus"],
    ["Family Goa Bus Tour", "Group Travel Goa Bus"],
    ["Affordable Goa Bus Package", "Chauffeur Driven Goa Bus"],
    ["Best Goa Tour Bus Pune", "Pune Goa Travel Bus"],
    ["Tourist Bus Hire Goa", "Beach Tour Bus Pune"],
    ["Holiday Bus Package Goa", "Night Travel Bus Goa"],
    ["Goa Trip Bus Service", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Goa Tour Package From Pune by Bus with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and well-planned Goa tour packages from Pune by bus, ideal for group tours, family vacations, friends trips, and corporate outings."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-maintained buses ensuring a relaxed and enjoyable journey from Pune to Goa."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
    "WhyChoosedescription": "Our professional drivers are experienced with Pune–Goa routes, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Goa tour packages from Pune by bus, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from weekend trips, multi-day tours, or fully customized Goa tour packages as per your group’s preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual departures and dependable service, making Sanavi Travels a trusted choice for Goa bus tours from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Goa tour packages from Pune by bus?',
    answer: 'Yes, Sanavi Travels provides well-organized and comfortable Goa tour packages from Pune by bus.'
  },
  {
    question: 'How can I book a Goa tour package from Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Goa tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for long-distance group travel.'
  },
  {
    question: 'Are drivers included in the Goa bus tour package?',
    answer: 'Yes, all tour packages include experienced and professional drivers familiar with the Pune–Goa route.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Goa tour package from Pune?',
    answer: 'Absolutely. Sanavi Travels offers customized Goa tour packages according to your travel requirements.'
  },
  {
    question: 'What payment options are available for the Goa tour package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the tour?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Goa journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Joshi',
    feedback: 'Booked a Goa tour package from Pune by bus with Sanavi Travels. Comfortable journey, professional driver, and great service throughout.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Patwardhan',
    feedback: 'Wonderful experience! Clean bus, smooth travel, and excellent coordination. Sanavi Travels made our Goa trip stress-free.',
    rating: 5
  }
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gujarat Bus Hire Package - Sanavi Travels",
  "description": "Pune to Gujarat bus hire package by Sanavi Travels for family trips, group travel, religious tours, and holiday trips. Choose AC and luxury buses for safe, comfortable, and affordable long-distance travel from Pune to Gujarat.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Gujarat Bus Hire Package Starting from ₹55 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Gujarat bus hire packages with Sanavi Travels. AC and luxury buses for family trips, group travel, religious tours, and holiday trips at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogijratbushirepackage;